export default {
    data() {
        return {
            componentsKeys: {}
        };
    },
    methods: {
        getRandomKey(prefix = "") {
            return prefix + Math.random();
        },
        updateComponentKey(ref) {
            const key = this.getRandomKey(ref);
            this.$set(this.componentsKeys, ref, key);
            return key;
        },
    }
}
